$.urbanApp = {
  name: 'Urban',
  author: 'Nyasha',
  version: '1.0.0',
  year: (new Date()).getFullYear(),
  'default': '#e2e2e2',
  font: 'RobotoDraft',
  primary: '#09c',
  success: '#2ECC71',
  warning: '#ffc65d',
  danger: '#d96557',
  info: '#4cc3d9',
  white: 'white',
  dark: '#4C5064',
  border: '#e4e4e4',
  bodyBg: '#e0e8f2',
  textColor: '#6B6B6B',
};
